(function () {
  class SlotMachine {
    constructor() {
      this.reels = [];
      this._reelVisuals = [];
      this._minimumSpinTime = 0;
      this._modes = {};
      this._currentMode = undefined;
      this._currentModeName = undefined;
      this._reelsSpinning = [];
      this._spinCompleteCallback = undefined;
      this._pullbackStartedCallbacks = [];
      this._accelerationStartedCallbacks = [];
      this._reelLandedCallbacks = [];
      this._reelHitCallbacks = [];
      this._reelNewSymbolCallbacks = [];
      this._reelOldSymbolCallbacks = [];
      this._reelSymbolChangedCallbacks = [];
      this._spinAbortedCallbacks = [];
      this._reelsSpinningCallbacks = [];
      this._allReelsTargetSymbols = [];
      this._reelBandLengths = [];
      this._boundUpdate = this.update.bind(this);
      this._enabled = false;
      this._loggingEnabled = false;
      this._symbolTrackers = {};
      this._injectorCreators = require("./Injectors.js");
      this._controlledObjectCreator = require("../../ControlledObject.js");
      this.logger = this.logMessage.bind(this);
      this._reelsHeld = [];
      this.clearHeldReels();
      this.enable();

      //////////////////////////////
      // Dynamic Spinner
      this._dynamicSpinnerActive = false;
      this._dynamicSpinners = [];
      this._dynamicInjectors = [];
      this._dynamicInjectorData = undefined;
      //////////////////////////////

      this._callbacksObj = {
        pullbackCB: (reelId) => {
          this.pullbackStartedOnReel(reelId);
        },
        accelerationCB: (reelId) => {
          this.accelerationStartedOnReel(reelId);
        },
      };
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    // Dynamic Spinner Handled Here
    // NOTE: I don't like how references are created here to the spinner and injector.
    // Looking to refactor SlotMachine to handle this in a better way.
    // Getting injector here to pass through landing positions, symbols weightings and symbol rules
    setDynamicSpinner(dynamicSpinner) {
      this._dynamicSpinnerActive = dynamicSpinner;

      if (this._dynamicSpinnerActive) {
        for (let i = 0; i < this._reelVisuals.length; ++i) {
          // Having to get dynamic spinners from reel visuals. Is this the correct place????
          this._dynamicSpinners.push(this._reelVisuals[i].getReelSpinnerData());

          // And then having to get the injectors from the dynamic spinners.
          // Injectors are created in the dynamic spinner, and need it to tell injector where to spin too...
          // ...but SlotMachine needs them for landing positions, symbols weightings and symbol rules
          // Think about how to refactor this
          this._dynamicInjectors.push(this._dynamicSpinners[i].getInjectors());
          this._dynamicSpinners[i].loadInjector(this._dynamicInjectorData);
        }
      }
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////

    logMessage(message) {
      if (this._loggingEnabled) {
        console.log(message);
      }
    }

    getBounds() {
      let clipRectFirstReel = this._reelVisuals[0]._clipRect;

      return {
        x: clipRectFirstReel.x,
        y: clipRectFirstReel.y,
        width: clipRectFirstReel.width * this._reelVisuals.length,
        height: clipRectFirstReel.height,
      };
    }

    getSymbolId(reel, row) {
      return this.reels[reel].getSymbolData()[row].symId;
    }

    getMinSymbolSpacing(reel) {
      return this.reels[reel]._minSymbolSpacing;
    }

    getSymbolPosition(reel, row) {
      let res = this._reelVisuals[reel].position;
      return {
        x: res.getX(),
        y: res.getY() + row * this.reels[reel]._minSymbolSpacing,
      };
    }

    setLoggingEnabled(enabled) {
      this._loggingEnabled = enabled;
    }

    getEnabled() {
      return this._enabled;
    }

    update(delta) {
      if (this.getEnabled()) {
        for (let i = 0; i < this._reelVisuals.length; ++i)
          this._reelVisuals[i].update(delta);
      }
    }

    getSymbolsInWindow() {
      let res = [];

      for (let i = 0; i < this.reels.length; ++i) {
        res.push(this.getSymbolsOnReel(i));
      }
      return res;
    }

    getSymbolsOnReel(reel) {
      let data = this.reels[reel].getSymbolData();
      let res = [];
      for (let i = 0; i < data.length; ++i) {
        res.push(data[i].symId);
      }
      return res;
    }

    highlightSymbolIdsOnReel(reelId, symbolsToHighlight, duration = 0) {
      let configSymbols = resourceManager.getConfiguration().symbols;

      let symbolsToDim = []; // easier to work with symbols to dim than symbols to highlight under the hoods. But cleaner API for users to use highlights

      for (let prop in configSymbols) {
        if (configSymbols.hasOwnProperty(prop)) {
          let symbol = configSymbols[prop];
          if (symbolsToHighlight.indexOf(symbol.ID) === -1) {
            symbolsToDim.push(symbol.ID);
          }
        }
      }

      this._reelVisuals[reelId].dimSymbolIds(symbolsToDim, duration);
    }

    highlightSymbolIds(symbolsToHighlight, duration = 0) {
      for (let i = 0; i < this._reelVisuals.length; ++i) {
        this.highlightSymbolIdsOnReel(i, symbolsToHighlight, duration);
      }
    }

    reset() {
      for (let prop in this._modes) {
        if (this._modes.hasOwnProperty(prop)) {
          for (let i = 0; i < this._modes[prop].preInjectors.length; ++i) {
            this._modes[prop].preInjectors[i].reset();
            this._modes[prop].postInjectors[i].reset();
            this._modes[prop].dynamicInjectors[i].reset();
          }
        }
      }

      for (let i = 0; i < this._reelVisuals.length; ++i) {
        this._reelVisuals[i].reset();
      }
    }

    enable() {
      if (this.getEnabled()) return;
      if (checkForDefined(Reflex)) {
        Reflex.addToUpdate(this._boundUpdate);
      }
      this._enabled = true;
    }

    disable() {
      this._loggingEnabled = false;
      if (!this.getEnabled()) return;
      if (checkForDefined(Reflex)) {
        Reflex.removeFromUpdate(this._boundUpdate);
      }
      this._enabled = false;
    }

    // creates a ControlledObject for picking symbols from an array of symbol weights
    createWeightedSymbolsFromJson(symbolWeights) {
      let res = [];
      for (let i = 0; i < symbolWeights.length; ++i) {
        let weightedSymbols = this._controlledObjectCreator();
        let weightedArray = symbolWeights[i];
        for (let j = 0; j < weightedArray.length; ++j) {
          weightedSymbols.addOutcome(j, weightedArray[j]);
        }
        res.push(weightedSymbols);
      }
      return res;
    }

    // will create the appropriate rule based on rule type
    createRulesFromJson(injectorRules) {
      if (injectorRules === undefined) return [];
      let res = [];
      for (let i = 0; i < injectorRules.length; ++i) {
        let type = "";
        let uniqueName = "";

        do {
          type = "SymbolRules_" + injectorRules[i].type;
          uniqueName =
            type + "_" + (Math.random() + 1).toString(36).substring(2); // generates unique string
        } while (resourceManager.hasController(uniqueName));
        resourceManager.createController(uniqueName, type, injectorRules[i]);
        res.push(resourceManager.getController(uniqueName));
      }
      return res;
    }

    cloneMode(sourceMode, targetName) {
      if (this._modes[targetName]) {
        console.log(
          "Cannot clone mode to target name as it already exists " + targetName
        );
        return;
      }
      if (!this._modes[sourceMode]) {
        console.log(
          "Cannot clone mode from source name as it doesnt exists " + sourceMode
        );
        return;
      }

      let modeToClone = this._modes[sourceMode];

      let preInjectors = [];
      let postInjector = [];
      let dynamicInjector = [];

      let allSymbolWeights = this.createWeightedSymbolsFromJson(
        modeToClone.symbolWeights
      );
      for (let i = 0; i < modeToClone.reelData.length; ++i) {
        let allRules = this.createRulesFromJson(modeToClone.injectorRules[i]);
        preInjectors.push(
          this._injectorCreators().pre(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
        postInjector.push(
          this._injectorCreators().post(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
        dynamicInjector.push(
          this._injectorCreators().post(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
      }

      let mode = {
        injectorRules: JSON.parse(JSON.stringify(modeToClone.injectorRules)),
        symbolWeights: JSON.parse(JSON.stringify(modeToClone.symbolWeights)),
        reelData: JSON.parse(JSON.stringify(modeToClone.reelData)),
        preInjectors: preInjectors,
        postInjectors: postInjector,
        dynamicInjectors: dynamicInjector,
        minimumSpinTime: JSON.parse(
          JSON.stringify(modeToClone.minimumSpinTime)
        ),
        stopDistances: JSON.parse(JSON.stringify(modeToClone.stopDistances)), // how many extra symbols should subsequent reels spin to stagger. Element 0 is how much further reel 1 should spin than reel 0
      };

      this._modes[targetName] = mode;
    }

    createDynamicMode(sourceMode) {
      if (this._modes["dynamic"]) {
        delete this._modes["dynamic"];
      }
      this.cloneMode(sourceMode, "dynamic");
    }

    setupAnticipationSpin(anticipationReels) {
      if (!this._modes["anticipation"]) {
        console.log(
          "Cannot create anticipation mode if there isnt one defined. It just needs its stopDistances"
        );
        return;
      }

      let oldStopDistances = this._currentMode.stopDistances;
      let anticipationStopDistances = this._modes["anticipation"].stopDistances;

      for (let reelId = 1; reelId < this.reels.length; ++reelId) {
        // reelId = 1 because we cant anticipate the first reel
        let isAnticipating = anticipationReels.indexOf(reelId) !== -1;
        let previousReelTravelDistance = this.reels[reelId - 1]
          .getInjectors()
          .post.getMinTravelDistance();
        let thisReelTravelDistance = this.reels[reelId]
          .getInjectors()
          .post.getMinTravelDistance();

        let delta =
          thisReelTravelDistance -
          previousReelTravelDistance -
          oldStopDistances[reelId - 1];
        if (isAnticipating) {
          delta =
            anticipationStopDistances[reelId - 1] -
            oldStopDistances[reelId - 1]; // -1 because the stop distances are based on previous to current
          if (delta > 0) {
            let injectors = this.reels[reelId].getInjectors();
            injectors.post.setMinTravelDistance(
              previousReelTravelDistance + delta
            );
          }
        } else if (delta < 0) {
          let injectors = this.reels[reelId].getInjectors();
          injectors.post.setMinTravelDistance(
            previousReelTravelDistance + oldStopDistances[reelId]
          );
        }
      }
    }

    addDefaultSettings(settings) {
      this._dynamicInjectorData = settings.injectorData;
      let allSymbolWeights = this.createWeightedSymbolsFromJson(
        settings.symbolWeights
      );
      let minimumSpinTime = settings.minimumSpinTime || 2.5;
      minimumSpinTime =
        typeof gdk != "undefined"
          ? Math.max(gdk.minGameTime, minimumSpinTime)
          : minimumSpinTime; // test for gdk so doesnt break test suite

      if (gameData.minimalSpinningTime != undefined) {
        minimumSpinTime =
          gameData.minimalSpinningTime > 0
            ? gameData.minimalSpinningTime
            : minimumSpinTime;
      }

      let preInjectors = [];
      let postInjector = [];
      let dynamicInjector = [];

      for (let i = 0; i < settings.reelData.length; ++i) {
        let allRules = this.createRulesFromJson(settings.injectorRules[i]);
        preInjectors.push(
          this._injectorCreators().pre(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
        postInjector.push(
          this._injectorCreators().post(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
        dynamicInjector.push(
          this._injectorCreators().dynamic(
            allSymbolWeights[i],
            allRules,
            this.logger
          )
        );
      }

      let mode = {
        injectorRules: settings.injectorRules,
        symbolWeights: settings.symbolWeights,
        reelData: settings.reelData,
        preInjectors: preInjectors,
        postInjectors: postInjector,
        dynamicInjectors: dynamicInjector,
        minimumSpinTime: minimumSpinTime,
        stopDistances: settings.stopDistances, // how many extra symbols should subsequent reels spin to stagger. Element 0 is how much further reel 1 should spin than reel 0
      };
      this._modes["default"] = mode;
    }

    addNewModes(modes) {
      for (let prop in modes) {
        if (modes.hasOwnProperty(prop)) {
          if (prop == "default") {
            console.error("cannot have a slot machine mode called default");
            return;
          }

          let defaultMode = this._modes["default"];

          let symbolWeights;
          if (modes[prop].symbolWeights)
            symbolWeights = modes[prop].symbolWeights;
          else
            symbolWeights = JSON.parse(
              JSON.stringify(defaultMode.symbolWeights)
            );

          let allSymbolWeights =
            this.createWeightedSymbolsFromJson(symbolWeights);

          let minimumSpinTime =
            modes[prop].minimumSpinTime || defaultMode.minimumSpinTime;

          let reelData;
          if (modes[prop].reelData) reelData = modes[prop].reelData;
          else reelData = JSON.parse(JSON.stringify(defaultMode.reelData));

          let injectorRules;
          if (modes[prop].injectorRules)
            injectorRules = modes[prop].injectorRules;
          else
            injectorRules = JSON.parse(
              JSON.stringify(defaultMode.injectorRules)
            );

          let preInjectors = [];
          let postInjector = [];
          let dynamicInjector = [];
          for (let i = 0; i < reelData.length; ++i) {
            let allRules = this.createRulesFromJson(injectorRules[i]);
            preInjectors.push(
              this._injectorCreators().pre(
                allSymbolWeights[i],
                allRules,
                this.logger
              )
            );
            postInjector.push(
              this._injectorCreators().post(
                allSymbolWeights[i],
                allRules,
                this.logger
              )
            );
            dynamicInjector.push(
              this._injectorCreators().post(
                allSymbolWeights[i],
                allRules,
                this.logger
              )
            );
          }

          let stopDistances;
          if (modes[prop].stopDistances)
            stopDistances = modes[prop].stopDistances;
          else
            stopDistances = JSON.parse(
              JSON.stringify(defaultMode.stopDistances)
            );

          let mode = {
            injectorRules: injectorRules,
            symbolWeights: symbolWeights,
            reelData: reelData,
            preInjectors: preInjectors,
            postInjectors: postInjector,
            dynamicInjectors: dynamicInjector,
            minimumSpinTime: minimumSpinTime,
            stopDistances: stopDistances, // how many extra symbols should subsequent reels spin to stagger. Element 0 is how much further reel 1 should spin than reel 0
          };
          this._modes[prop] = mode;
        }
      }
    }

    // configures the slot machine from a json object
    initialise(json) {
      this.addDefaultSettings(json.defaultSettings);
      this.addNewModes(json.modes);
      this.selectReelMode("default");
    }

    addReel(reel) {
      this.reels.push(reel);
      reel.setLogger(this.logger);
      this._symbolTrackers["" + reel._reelId] = [];
    }

    addReelVisual(reelVisual) {
      this._reelVisuals.push(reelVisual);
    }

    clearTrackSymbolsRequests() {
      for (let prop in this._symbolTrackers) {
        if (this._symbolTrackers.hasOwnProperty(prop)) {
          this._symbolTrackers[prop] = [];
        }
      }
    }

    trackSymbolId(reelId, symbolId, onTrackCb, onUntrackedCb) {
      let trackInfo = this.constructSymbolTracker(
        reelId,
        symbolId,
        onTrackCb,
        onUntrackedCb
      );
      this._symbolTrackers["reel" + reelId].push(trackInfo);

      // check if any symbols in view can be tracked already
      let symbolData = this.reels[reelId].getSymbolData();
      let numInView = this.reels[reelId].getMaxSymbolsInWindow();
      for (let i = 0; i < numInView; ++i) {
        if (symbolData[i].symId === symbolId) {
          if (!this.isSymbolBeingTracked(reelId, symbolData[i].uniqueId)) {
            this.trackSymbol(symbolData[i], trackInfo, reelId, i);
            break;
          }
        }
      }
    }

    constructSymbolTracker(reelId, symbolId, onTrackCb, onUntrackedCb) {
      let self = this;

      let clipWidth = 0;
      for (let i = 0; i < this._reelVisuals.length; ++i) {
        clipWidth += this._reelVisuals[i].getClipRect().width;
      }

      let clipRect = this._reelVisuals[reelId].getClipRect();

      let clipBounds = {
        width: clipWidth,
        height: clipRect.height,
        x: this._reelVisuals[0].getClipRect().x,
        y: clipRect.y,
      };

      let trackInfo = {
        calleeTrack: onTrackCb,
        calleeUntrack: onUntrackedCb,
        calleeInfo: {
          reelId: reelId,
          symbolId: symbolId,
          uniqueSymbolId: undefined,
          showSymbol: undefined,
          getPosition: undefined,
          reservedSpace: 1,
          clipBounds: clipBounds,
          untrack: function () {
            self.removeSymbolTracker(
              reelId,
              trackInfo.calleeInfo.uniqueSymbolId
            );
          },
        },
      };
      return trackInfo;
    }

    trackSymbolInWindow(reelId, row, symbolId, onTrackCb, onUntrackedCb) {
      let trackInfo = this.constructSymbolTracker(
        reelId,
        symbolId,
        onTrackCb,
        onUntrackedCb
      );
      let symbolData = this.reels[reelId].getSymbolData();
      if (!this.isSymbolBeingTracked(reelId, symbolData[row].uniqueId)) {
        this.trackSymbol(symbolData[row], trackInfo, reelId, row);
        this._symbolTrackers["reel" + reelId].push(trackInfo);
      } else {
        console.log("Cannot track symbol in window, already being tracked");
      }
    }

    clearDimSymbolIds(duration = 0) {
      for (let i = 0; i < this._reelVisuals.length; ++i) {
        this._reelVisuals[i].clearDimSymbolIds(duration);
      }
    }

    trackSymbol(symbolData, trackInfo, reelId, windowOffset) {
      let self = this;
      trackInfo.calleeInfo.uniqueSymbolId = symbolData.uniqueId;
      trackInfo.calleeInfo.showSymbol = function (show) {
        self._reelVisuals[reelId].showSymbol(windowOffset, show);
      };
      trackInfo.calleeInfo.getPosition = function () {
        return self._reelVisuals[reelId].getSymbolPosition(windowOffset);
      };
      trackInfo.calleeInfo.reservedSpace =
        this.reels[reelId].getReservedSpace();
      trackInfo.calleeInfo.cell = {
        reel: reelId,
        row: windowOffset,
      };
      trackInfo.calleeTrack(trackInfo.calleeInfo);
    }

    isSymbolBeingTracked(reelId, uniqueId) {
      for (let i = 0; i < this._symbolTrackers["reel" + reelId].length; ++i) {
        if (
          this._symbolTrackers["reel" + reelId][i].calleeInfo.uniqueSymbolId ===
          uniqueId
        ) {
          return true;
        }
      }
      return false;
    }

    removeSymbolTracker(reelId, uniqueSymbolId) {
      for (let i = 0; i < this._symbolTrackers["reel" + reelId].length; ++i) {
        if (
          this._symbolTrackers["reel" + reelId][i].calleeInfo.uniqueSymbolId ===
          uniqueSymbolId
        ) {
          let unTrackFunc =
            this._symbolTrackers["reel" + reelId][i].calleeUntrack;
          let calleeInfo = this._symbolTrackers["reel" + reelId][i].calleeInfo;
          this._symbolTrackers["reel" + reelId].splice(i, 1);
          unTrackFunc(calleeInfo);
          break;
        }
      }
    }

    removeReel(reel) {
      const index = this.reels.indexOf(reel);
      if (index > -1) {
        this.reels.splice(index, 1);
      }
    }

    removeReelVisual(reel) {
      const index = this._reelVisuals.indexOf(reel);
      if (index > -1) {
        this._reelVisuals.splice(index, 1);
      }
    }

    assertNewSubscription(callbacks, func) {
      if (checkForDefined(Reflex) && Reflex.developerMode) {
        for (let i = 0; i < callbacks.length; ++i) {
          if (callbacks[i] === func) {
            console.log("---WARNING: Subscription already contains callback");
            return;
          }
        }
      }
    }

    //TODO REPLACE SUBSCRIPTIONS WITH ACTUAL EVENTS ETC. MAYBE JUST HAVE GENERIC SUBSCRIBE FUNCTION WHERE CALLEE SPECIFIES THE EVENT

    subscribeToPullbackStartedEvent(subscriber) {
      this.assertNewSubscription(this._pullbackStartedCallbacks, subscriber);
      this._pullbackStartedCallbacks.push(subscriber);
    }

    subscribeToAccelerationStartedEvent(subscriber) {
      this.assertNewSubscription(
        this._accelerationStartedCallbacks,
        subscriber
      );
      this._accelerationStartedCallbacks.push(subscriber);
    }

    subscribeToReelsLandedEvent(subscriber) {
      this.assertNewSubscription(this._reelLandedCallbacks, subscriber);
      this._reelLandedCallbacks.push(subscriber);
    }

    subscribeToReelsHitEvent(subscriber) {
      this.assertNewSubscription(this._reelHitCallbacks, subscriber);
      this._reelHitCallbacks.push(subscriber);
    }

    subscribeToNewSymbolEvent(subscriber) {
      this.assertNewSubscription(this._reelNewSymbolCallbacks, subscriber);
      this._reelNewSymbolCallbacks.push(subscriber);
    }

    subscribeToOldSymbolEvent(subscriber) {
      this.assertNewSubscription(this._reelOldSymbolCallbacks, subscriber);
      this._reelOldSymbolCallbacks.push(subscriber);
    }

    subscribeToSymbolChangedEvent(subscriber) {
      this.assertNewSubscription(this._reelSymbolChangedCallbacks, subscriber);
      this._reelSymbolChangedCallbacks.push(subscriber);
    }

    subscribeToSpinAbortedEvent(subscriber) {
      this.assertNewSubscription(this._spinAbortedCallbacks, subscriber);
      this._spinAbortedCallbacks.push(subscriber);
    }

    subscribeToReelsSpinningEvent(subscriber) {
      this.assertNewSubscription(this._reelsSpinningCallbacks, subscriber);
      this._reelsSpinningCallbacks.push(subscriber);
    }

    unsubscribeFromEvent(callbacks, subscriber) {
      for (let i = 0; i < callbacks.length; ++i) {
        if (subscriber === callbacks[i]) {
          callbacks.splice(i, 1);
          return;
        }
      }

      console.log("---WARNING: No Subscription to Unsubscribe from");
    }

    unsubscribeToPullbackStartedEvent(subscriber) {
      this.unsubscribeFromEvent(this._pullbackStartedCallbacks, subscriber);
    }

    unsubscribeToAccelerationStartedEvent(subscriber) {
      this.unsubscribeFromEvent(this._accelerationStartedCallbacks, subscriber);
    }

    unsubscribeToReelsHitEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelHitCallbacks, subscriber);
    }

    unsubscribeToReelsLandedEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelLandedCallbacks, subscriber);
    }

    unsubscribeToNewSymbolEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelNewSymbolCallbacks, subscriber);
    }

    unsubscribeToOldSymbolEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelOldSymbolCallbacks, subscriber);
    }

    unsubscribeToSymbolChangedEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelSymbolChangedCallbacks, subscriber);
    }

    unsubscribeToSpinAbortedEvent(subscriber) {
      this.unsubscribeFromEvent(this._spinAbortedCallbacks, subscriber);
    }

    unsubscribeToReelsSpinningEvent(subscriber) {
      this.unsubscribeFromEvent(this._reelsSpinningCallbacks, subscriber);
    }

    // switch slot machine into one of the modes privided on on initialisation from json
    selectReelMode(mode) {
      // todo , error check if mode doesnt exist
      this._currentModeName = mode;
      this._currentMode = this._modes[mode];
      for (let i = 0; i < this.reels.length; ++i) {
        this.reels[i].setReelParameters(this._currentMode.reelData[i]);
        this.reels[i].setInjectors(
          this._currentMode.preInjectors[i],
          this._currentMode.postInjectors[i],
          this._currentMode.dynamicInjectors[i]
        );
      }
    }

    getCurrentReelMode() {
      return this._currentModeName;
    }

    setReelSymbol(reelId, index, symbolId) {
      this.reels[reelId].setReelSymbol(index, symbolId);
      for (let i = 0; i < this._reelSymbolChangedCallbacks.length; ++i) {
        this._reelSymbolChangedCallbacks[i](reelId, symbolId);
      }
    }

    setPreappertureSymbol(reelId, preAppIdx, symbolId) {
      let preAppStartIdx = this.reels[reelId]._preAppertureSymbolIdx;
      let numPreapp = this.reels[reelId]._preAppertureSymbols;

      if (preAppIdx < numPreapp) {
        this.setReelSymbol(reelId, preAppStartIdx + preAppIdx, symbolId);
      } else {
        console.log(
          "Cannot set preapperture symbol for reelId: " +
            reelId +
            " at preAppIdx offset: " +
            preAppIdx +
            " as it only has: " +
            numPreapp +
            " preapperture symbols"
        );
      }
    }

    setAllSymbolsOnAReel(reelId, reelSymbols) {
      for (let i = 0; i < reelSymbols.length; ++i) {
        this.setReelSymbol(reelId, i, reelSymbols[i]);
      }
    }

    setAllReelSymbols(allSymbols) {
      for (let i = 0; i < this.reels.length; ++i) {
        this.setAllSymbolsOnAReel(i, allSymbols[i]);
      }
    }

    dimSymbol(reel, row, showDim, time) {
      this.dimSymbols([{ reel: reel, row: row }], showDim, time);
    }

    dimSymbols(symbols, showDim, time) {
      for (let i = 0; i < symbols.length; ++i) {
        this._reelVisuals[symbols[i].reel].dimSymbol(
          symbols[i].row,
          showDim,
          time
        );
      }
    }

    dimSymbolsOnReels(reels, showDim, time) {
      let symbols = [];
      for (let i = 0; i < reels.length; ++i) {
        for (let j = 0; j < this.reels[reels[i]].getTotalAppertureSize(); ++j)
          symbols.push({ reel: reels[i], row: j });
      }
      this.dimSymbols(symbols, showDim, time);
    }

    dimAllSymbols(showDim, time) {
      let symbols = [];
      for (let i = 0; i < this.reels.length; ++i) {
        for (let j = 0; j < this.reels[i].getTotalAppertureSize(); ++j)
          symbols.push({ reel: i, row: j });
      }
      this.dimSymbols(symbols, showDim, time);
    }

    convertReelStringToIndex(str) {
      return str.substr(4, str.length);
    }

    // callback system for when a new symbol has come into view on a reel
    onNewSymbol(reelId, symbolData, windowOffset) {
      let self = this;
      let reelIndex = this.convertReelStringToIndex(reelId);
      for (let i = 0; i < this._reelNewSymbolCallbacks.length; ++i) {
        this._reelNewSymbolCallbacks[i](reelId, symbolData.symId);
      }

      // symbol trackers that are currently tracking an in view symbol need to continue tracking it
      // but the way the slot machine works is it only spins by one symbol height before resetting positions
      // and copying the symbol data one symbol beneath. All symbols trackers need to point down to the next
      // symbol to continue their track. This should all be under the hood here.
      // Dont worry if the symbol has now gone off screen, as it was handled by the onOldSymbol callback

      let reelsSymbolData = this.reels[reelIndex].getSymbolData();
      for (let i = 0; i < this._symbolTrackers[reelId].length; ++i) {
        let trackInfo = this._symbolTrackers[reelId][i];
        if (trackInfo.calleeInfo.uniqueSymbolId !== undefined) {
          // this is currently tracking a symbol
          // check if any symbols in view can be tracked already

          let found = false;
          for (let j = 0; j < reelsSymbolData.length; ++j) {
            if (
              reelsSymbolData[j].uniqueId ===
              trackInfo.calleeInfo.uniqueSymbolId
            ) {
              // this symbol has the same uniqueSymbolId as a tracker, meaning it is technically the same symbol just one further down
              // updat the links
              trackInfo.calleeInfo.showSymbol = function (show) {
                self._reelVisuals[reelIndex].showSymbol(j, show);
              };
              trackInfo.calleeInfo.getPosition = function () {
                return self._reelVisuals[reelIndex].getSymbolPosition(j);
              };
              trackInfo.calleeInfo.reservedSpace =
                this.reels[reelIndex].getReservedSpace();
              found = true;
              break;
            }
          }
          if (!found) {
            console.log(
              "====Could not find symbol to track with unique Id: " +
                trackInfo.calleeInfo.uniqueSymbolId
            );
            break;
          }
        }
      }

      // check if any of the symbol trackers waiting are for this new symbol
      for (let i = 0; i < this._symbolTrackers[reelId].length; ++i) {
        let trackInfo = this._symbolTrackers[reelId][i];
        if (
          trackInfo.calleeInfo.uniqueSymbolId === undefined &&
          trackInfo.calleeInfo.symbolId === symbolData.symId
        ) {
          this.trackSymbol(
            symbolData,
            trackInfo,
            trackInfo.calleeInfo.reelId,
            windowOffset
          );
          break;
        }
      }
    }

    // callback system for when a symbol has gone out of view and is no longer in the reel data
    onOldSymbol(reelId, symbolData, windowOffset) {
      for (let i = 0; i < this._reelOldSymbolCallbacks.length; ++i) {
        this._reelOldSymbolCallbacks[i](reelId, symbolData.symId);
      }

      for (let i = 0; i < this._symbolTrackers[reelId].length; ++i) {
        let trackInfo = this._symbolTrackers[reelId][i];
        if (trackInfo.calleeInfo.uniqueSymbolId === symbolData.uniqueId) {
          trackInfo.calleeInfo.untrack();
          break;
        }
      }
    }

    onReelBandConstructed(reelId, additionalLength) {
      this._reelBandLengths[reelId] = additionalLength;

      let allBandsComplete = true;
      for (let i = 0; i < this._reelBandLengths.length; i++) {
        if (this._reelBandLengths[i] === -1) {
          allBandsComplete = false;
        }
      }

      if (allBandsComplete) {
        const maxAdditionalLength = Math.max(...this._reelBandLengths);

        for (let i = 0; i < this._reelBandLengths.length; i++) {
          this.reels[i].prepareFinalBand(maxAdditionalLength);
        }
      }
    }

    // tells also reels to spin indefinitely
    infiniteSpin() {
      let self = this;
      for (let i = 0; i < this.reels.length; ++i) {
        if (this._reelsHeld.indexOf(i) !== -1) continue;
        this.reels[i].startSpin(
          function (reelId, symbolId, windowOffset) {
            self.onNewSymbol(reelId, symbolId, windowOffset);
          },
          function (reelId, symbolId, windowOffset) {
            self.onOldSymbol(reelId, symbolId, windowOffset);
          }
        );
      }
      for (let i = 0; i < this._reelsSpinningCallbacks.length; ++i) {
        this._reelsSpinningCallbacks[i]();
      }

      /*
                this.reels[5].startSpin(function(reelId, symbolId){
                    self.onNewSymbol(reelId, symbolId);
                });
  */
    }

    pullbackStartedOnReel(reelId) {
      for (let i = 0; i < this._pullbackStartedCallbacks.length; ++i) {
        this._pullbackStartedCallbacks[i](reelId);
      }
    }

    accelerationStartedOnReel(reelId) {
      for (let i = 0; i < this._accelerationStartedCallbacks.length; ++i) {
        this._accelerationStartedCallbacks[i](reelId);
      }
    }

    dynamicSpin(spinConfig) {
      // Looking the replace infiniteSpin with dynamicSpin
      // but copying structure for now
      let self = this;
      this._reelBandLengths = [];
      this._reelBandLengths.length = this.reels.length;
      this._reelBandLengths.fill(-1);
      for (let i = 0; i < this.reels.length; ++i) {
        const reelName = "reel" + i;
        if (spinConfig[reelName] === undefined) {
          this._reelBandLengths[i] = 0;
        } else {
          this._reelBandLengths[i] = -1;
        }
        if (this._reelsHeld.indexOf(i) !== -1) continue;
        this.reels[i].setCallbacks(this._callbacksObj);
        this.reels[i].startDynamicSpin(
          function (reelId, symbolId, windowOffset) {
            self.onNewSymbol(reelId, symbolId, windowOffset);
          },
          function (reelId, symbolId, windowOffset) {
            self.onOldSymbol(reelId, symbolId, windowOffset);
          },
          function (reelId, additionalLength) {
            self.onReelBandConstructed(reelId, additionalLength);
          },
          spinConfig
        );
        // This doesn't actually do anything, but the game specific
        // reel visual needs to know when a spin starts
        this._reelVisuals[i].startDynamicSpin();
      }
      for (let i = 0; i < this._reelsSpinningCallbacks.length; ++i) {
        this._reelsSpinningCallbacks[i]();
      }
    }

    // instantly stops all reels from spinning
    slamStop() {
      let reelsToSlam = [];
      for (let i = 0; i < this.reels.length; ++i) {
        reelsToSlam.push(i);
      }
      this.slamReels(reelsToSlam);
    }

    slamReels(reelsToSlam) {
      for (let i = 0; i < reelsToSlam.length; ++i) {
        this.reels[reelsToSlam[i]].slamStop();
      }
    }

    popSymbols(popData, callback) {
      const numReels = this._reelVisuals.length;
      let numReelsPopped = 0;
      function onReelPopComplete() {
        ++numReelsPopped;
        if (numReels === numReelsPopped) {
          callback();
        }
      }

      for (let i = 0; i < this._reelVisuals.length; ++i) {
        this._reelVisuals[i].popSymbols(popData[i], onReelPopComplete);
      }
    }

    dropSymbols(popData, newWindow, callback) {
      const numReels = this._reelVisuals.length;
      let numReelsDropped = 0;
      function onReelDropComplete() {
        ++numReelsDropped;
        if (numReels === numReelsDropped) {
          callback();
        }
      }

      for (let i = 0; i < this._reelVisuals.length; ++i) {
        let numSymbolsDropping = popData[i].reduce(function (prev, cur) {
          return prev + cur;
        }, 0);

        if (numSymbolsDropping !== 0) {
          this._reelVisuals[i].dropSymbols(
            popData[i],
            newWindow[i],
            onReelDropComplete
          );
        } else {
          ++numReelsDropped;
        }
      }
    }

    // stops infinitely spinning reels before they have been told to land to a target positions.
    // a use case is spinning reels that you cant afford to play
    abortSpin() {
      for (let i = 0; i < this.reels.length; ++i) {
        this.reels[i].abortSpin();
      }

      for (let i = 0; i < this._spinAbortedCallbacks.length; ++i) {
        this._spinAbortedCallbacks[i]();
      }
    }

    onReelHit(reelId) {
      for (let i = 0; i < this._reelHitCallbacks.length; ++i) {
        this._reelHitCallbacks[i](reelId);
      }
    }

    // callback system for when a reel has come to a complete stop
    onReelLanded(reelId) {
      for (let i = 0; i < this._reelLandedCallbacks.length; ++i) {
        this._reelLandedCallbacks[i](reelId);
      }

      let idx = this._reelsSpinning.indexOf(reelId);
      if (idx !== -1) {
        this._reelsSpinning.splice(idx, 1);
        if (this._reelsSpinning.length === 0 && this._spinCompleteCallback) {
          if (this._dynamicSpinnerActive) {
            for (let i = 0; i < this.reels.length; ++i) {
              this._reelVisuals[i].dynamicSpinComplete();
            }
          }
          this._spinCompleteCallback();
        }
      } else {
        // TODO
      }
    }

    setInitialSymbols(symbols) {
      for (var i = 0; i < this.reels.length; ++i) {
        var startingReelSymbols = symbols[i].symbols;
        let abortSymbols = [];
        for (let j = 0; j < startingReelSymbols.length; ++j) {
          this.setReelSymbol(i, j, +startingReelSymbols[j].value); // apparently the + is a very quick way of converting string to int
          abortSymbols.push(+startingReelSymbols[j].value);
        }
        this.reels[i].setAbortSymbols(abortSymbols);
      }
    }

    constructTargetBand(result, above, below) {
      let targetSymbols = above; // symbols are popped in reverse order so start from above
      targetSymbols = targetSymbols.concat(result); // add results
      targetSymbols = targetSymbols.concat(below); // add below
      return targetSymbols;
    }

    getNumberOfTargetSymbolsToSpin(
      result,
      above,
      below,
      ruleEnforcedSymbols,
      isReversed
    ) {
      if (!isReversed) {
        return (
          below.length +
          result.length +
          ruleEnforcedSymbols.length +
          (this.reels[0]._preAppertureSymbols - 1)
        );
      } else {
        return (
          above.length +
          result.length +
          (this.reels[0]._postAppertureSymbols - 1)
        ); // dont include enforces as they are under the below symbols, neither of which go past the window
      }
    }

    // the below symbols may contain part of a group, so we need to make sure that we also attach the
    // required symbols too
    calculateEnforcedSymbols(targetSymbols, reelIndex) {
      return this._currentMode.postInjectors[
        reelIndex
      ].calculateProceedingSymbols(targetSymbols);
    }

    concatEnforcedRulesToTarget(targetSymbols, enforcedSymbols) {
      return targetSymbols.concat(enforcedSymbols);
    }

    // returns how long in generic units it will take to X symbols based on the reels current appertureHeight.
    // smallest symbol size (maxAppertureHeight) will take 1 unit to spin
    symbolsToTravelUnit(maxAppertureHeight, apeprtureHeight, numSymbols) {
      return (maxAppertureHeight / apeprtureHeight) * numSymbols;
    }

    // returns what the new spin time should be (if any) to meet the miniumum spin requirements at the current reel speed
    enforceMiniumumSpinTime(currentTravelTime, maxAppertureHeight, reels) {
      let newTravelTime = currentTravelTime;
      let firstReelAppertureHeightDuringInfiniteSpin = reels[0].length;
      let symbolsSpunFirstReel =
        this._currentMode.preInjectors[0].getNumSymbolsInjected();
      let lastReelIdx = this.reels.length - 1;
      let spinSpeed = this.reels[lastReelIdx].getCurrentSymbolsPerSecond();
      let timeAlreadySpun =
        (this.symbolsToTravelUnit(
          maxAppertureHeight,
          firstReelAppertureHeightDuringInfiniteSpin,
          1
        ) *
          symbolsSpunFirstReel) /
        spinSpeed; // how long was inifinite spin active
      let minSpinTime = Math.max(
        this._currentMode.minimumSpinTime - timeAlreadySpun,
        0
      );
      let bouceTime =
        this._currentMode.reelData[this._currentMode.reelData.length - 1]
          .bounceTime;

      // take into account the time it needs to bounce
      minSpinTime = Math.max(minSpinTime - bouceTime, 0);

      // do we need to increase the distance of last reel to cater for min spin time?
      if (newTravelTime / spinSpeed < minSpinTime) {
        let lastReelAppertureHeight = reels[lastReelIdx].length;
        let timeToSpinASymbol = this.symbolsToTravelUnit(
          maxAppertureHeight,
          lastReelAppertureHeight,
          this.reels[lastReelIdx].getReservedSpace()
        );
        do {
          newTravelTime += timeToSpinASymbol;
        } while (newTravelTime / spinSpeed < minSpinTime);
      }
      return newTravelTime;
    }

    // returns how long it will take to spin the minimum amount of symbols that it knows about.
    // so the target symbol (result symbols, below symbols (if not reversed), above symbols (if reversed), enforced symbols)
    // including symbols in the preinjector that need to complete a currently dynamic symbols rule (like if we are half way though spinning a group)
    // and the amount left of the current preapperture symbol ratio
    calculateTravelTimeForKnownSymbols(
      reelIndex,
      travelDistanceUntilLanded,
      maxAppertureHeight,
      reverseSpin
    ) {
      let res = 0;
      // how long to spin the target symbols (result, above, below, enforcedRules)
      let currentReelApperture =
        this.reels[reelIndex].getCurrentAppertureHeight();
      res = this.symbolsToTravelUnit(
        maxAppertureHeight,
        currentReelApperture,
        travelDistanceUntilLanded
      );

      // how long to spin any rules that needed to be fulfilled, like extra symbols to fill currently displayed group (not the same as enforced rules)
      let numSymbolsNeededToFulfulPreInjectorRules =
        this._currentMode.preInjectors[reelIndex]._proceedingSymbols.length;
      res +=
        this.symbolsToTravelUnit(maxAppertureHeight, currentReelApperture, 1) *
        numSymbolsNeededToFulfulPreInjectorRules;

      // dont forget the time it takes to spin the current Preapperture symbol which may have a diffrerent apperture height
      let leftOver =
        1 -
        this.reels[reelIndex].getRatioOfPreappertureSymbolInView(reverseSpin); // how much of the current preappreture symbol do we still need to spin in

      // because the preappreture symbol is currently being spun in we cant assume its apperture height is the same as currentReelApperture as it might have changed
      res += this.symbolsToTravelUnit(
        maxAppertureHeight,
        this.reels[reelIndex].getSymbolAppertureHeight(
          this.reels[reelIndex]._preAppertureSymbolIdx
        ),
        leftOver
      );
      return res;
    }

    nudgeReels(
      reelsToNudge,
      aboveSymbolIds,
      belowSymbolIds,
      spinCompleteCallback
    ) {
      this._spinCompleteCallback = spinCompleteCallback;
      this._reelsSpinning = [];
      for (let i = 0; i < reelsToNudge.length; ++i) {
        let reelIdx = reelsToNudge[i].reelId;
        let resultWindow = reelsToNudge[i].result;

        this._reelsSpinning.push(this.reels[reelIdx]._reelId);
        this.reels[reelIdx].nudgeReel(
          resultWindow,
          this.onReelLanded.bind(this)
        );
        //   this.onNewSymbol(reelIdx,0);
      }
    }

    holdReels(reelsToHold) {
      this._reelsHeld = reelsToHold;
    }

    clearHeldReels() {
      this.holdReels([]);
    }

    // this function causes the reels to come out of their infinite spin and show the spin result
    // it is complicated because it needs to tell the reels how long to spin for until they are allowed to land
    // it takes into account how many symbols left until it reaches its minimum spin time
    // how many symbols are needed by the preinjector to satisfy all games rules.
    // it then convers this into TIME to see how long it will take the reel with the maximum symbols to land
    // however it isnt just the number of symbols that result in the longest spin. Megaways has bigger symbols
    // and bigger symbols take longer to spin due to their size. So this also has to be taken into account
    stopReels(
      result,
      aboveSymbolIds,
      belowSymbolIds,
      spinCompleteCallback,
      landConfig
    ) {
      // callback for when spinning has complete
      this._spinCompleteCallback = spinCompleteCallback;
      let lastReelIdx = this.reels.length - 1;
      this._allReelsTargetSymbols = []; //merged results, above and below
      let travelDistanceUntilLanded = [];

      this.logger("--Result: " + JSON.stringify(result));
      this.logger("--Above: " + JSON.stringify(aboveSymbolIds));
      this.logger("--Below: " + JSON.stringify(belowSymbolIds));

      // store how many symbols need to be span to obey min spin time and rules
      for (let i = 0; i < this.reels.length; ++i) {
        let reverseSpin = this.reels[i]._reelParameters.reverse;
        // Replaced old above/below symbols. Injector handles this now.
        let targetSymbols = this.constructTargetBand(result[i], [], []);
        let ruleEnforcedSymbols = this.calculateEnforcedSymbols(
          targetSymbols,
          i
        );

        targetSymbols = this.concatEnforcedRulesToTarget(
          targetSymbols,
          ruleEnforcedSymbols,
          reverseSpin
        );
        // Replaced old above/below symbols. Injector handles this now.
        let numberOfTargetToSpin = this.getNumberOfTargetSymbolsToSpin(
          result[i],
          [],
          [],
          ruleEnforcedSymbols,
          reverseSpin
        );

        if (reverseSpin) {
          targetSymbols = targetSymbols.reverse();
        }
        this._allReelsTargetSymbols.push(targetSymbols);
        travelDistanceUntilLanded.push(numberOfTargetToSpin);
      }

      // this only works if the reels dont have differeing heights
      let maxAppertureHeight = this.reels[0].getMaxSymbolsInWindow();

      // array to store how long each reel will take to land
      let travelTimes = [];

      // calculate how long each reel will take fully land
      for (let i = 0; i < this.reels.length; ++i) {
        let reverseSpin = this.reels[i]._reelParameters.reverse;
        travelTimes.push(
          this.calculateTravelTimeForKnownSymbols(
            i,
            travelDistanceUntilLanded[i],
            maxAppertureHeight,
            reverseSpin
          )
        );

        // this ensures that we cant have a short spin without any dynamic symbols because without dynamic symbols you are only left
        // with source and target positions that when concatenated may break injector rules
        travelTimes[i] += this.symbolsToTravelUnit(
          maxAppertureHeight,
          this.reels[i].getCurrentAppertureHeight(),
          this.reels[i].getReservedSpace()
        );
      }

      // lets start handling miniumum spin time, assumes the first reel started spinning first
      // WHEN COMMENINT THIS BACK IN MAKE SURE IT DOESNT AFFECT FACTOR OF SYMBOLS OF DYNAMIC BANDS NEEDED TO FIT A FULL GIGABLOX
      travelTimes[lastReelIdx] = this.enforceMiniumumSpinTime(
        travelTimes[lastReelIdx],
        maxAppertureHeight,
        result
      );

      // reorder the travel times to make them staggered
      // this is more complicated that I thought it was going to be! Basically in order to produce a staggerd left to right landing we cannot
      // use a static stagger time between reels. This is because the stagger time will more than likely not be a factor of how long it takes
      // to spin a dynamic apperture height symbol. So the stagger times are treated as a minimum time between reels landing and the actualy
      // time is a fact of how long it takes to spin a symbol at it's current apperture height. This keeps the travelTimes array completely
      // divisible by number of symbols spinning (remember that travelTimes contains the preapperture symbol which maybe of a different apperture height
      // but that is taken care of)
      let stopDistances = this._currentMode.stopDistances;
      for (let i = 0; i < this.reels.length - 1; ++i) {
        let nextReelApperture = this.reels[i + 1].getCurrentAppertureHeight();
        let staggeredGap = this.symbolsToTravelUnit(
          maxAppertureHeight,
          nextReelApperture,
          stopDistances[i]
        );
        let thisReelSpeed = this.reels[i].getCurrentSymbolsPerSecond();
        let nextReelSpeed = this.reels[i + 1].getCurrentSymbolsPerSecond();
        let thisReelTime = travelTimes[i]; // how long currently for this reel to land
        let normalisedSpeed = nextReelSpeed / thisReelSpeed;
        thisReelTime *= normalisedSpeed;
        let nextReelTime = travelTimes[i + 1]; // how long currently for the reel to its right to land
        let isFirstReelSpinningLonger = thisReelTime >= nextReelTime; // is the first reel spinning longer than the second?
        let isSecondReelStaggerToCloseToFirst =
          !isFirstReelSpinningLonger &&
          thisReelTime + staggeredGap > nextReelTime; // is the second spinning longer but not obeying the minimum stagger gap?
        let thisReelReservedSpaces = this.reels[i].getReservedSpace();
        let nextReelReservedSpaces = this.reels[i + 1].getReservedSpace();

        if (isFirstReelSpinningLonger || isSecondReelStaggerToCloseToFirst) {
          // we have to increate how long the reel to the right of this one spins for so it is longer than the miniumum stagger time
          // keep adding the time it takes to spin one whole symbol on to it's time until >= minimum stagger time
          let timeToSpinOneSymbolNextReel = this.symbolsToTravelUnit(
            maxAppertureHeight,
            nextReelApperture,
            nextReelReservedSpaces
          );
          do {
            nextReelTime += timeToSpinOneSymbolNextReel;
          } while (thisReelTime + staggeredGap > nextReelTime);
          travelTimes[i + 1] = nextReelTime;
        } else {
          // this scenario is that the symbol to the right of this symbol maybe a long time in front of this reel
          // so increase the time this reel takes until it is as close to the right reels landing time taking into account minimum stagger
          // time as you can get.
          let thisReelApperture = this.reels[i].getCurrentAppertureHeight();
          let timeToSpinOneSymbolThisReel =
            this.symbolsToTravelUnit(
              maxAppertureHeight,
              thisReelApperture,
              thisReelReservedSpaces
            ) * normalisedSpeed;

          // keep increasing this reels spin time until it is no closer to the nextReels time than the staggered gap
          while (
            thisReelTime + timeToSpinOneSymbolThisReel <
            nextReelTime - staggeredGap
          ) {
            thisReelTime += timeToSpinOneSymbolThisReel;
          }

          // set the new time of this reel
          travelTimes[i] = thisReelTime;

          // now we have changed this reels travel time we may have to increase the travel time of all subsequent reels to get them
          // as close to each other as possible again. We only INCREASE these reels times so we never impact how long we need to spin
          // to get the target symbols in time.
          for (let j = i - 1; j >= 0; --j) {
            let newThisReel = travelTimes[j]; // how long does this reel take to land
            let newNextReel = travelTimes[j + 1]; // how long does the next reel take to land
            let newThisReelSpeed = this.reels[j].getCurrentSymbolsPerSecond();
            let newNextReelSpeed =
              this.reels[j + 1].getCurrentSymbolsPerSecond();
            let newNormalisedSpeed = newThisReelSpeed / newNextReelSpeed;
            let newThisReelApperture =
              this.reels[j].getCurrentAppertureHeight();
            let newStaggeredGap = this.symbolsToTravelUnit(
              maxAppertureHeight,
              newThisReelApperture,
              stopDistances[j]
            ); // what is the minimume stagger distance between these two reels
            let newThisReelReservedSpaces = this.reels[j].getReservedSpace();
            let newThisTimeToSpinOneSymbol =
              this.symbolsToTravelUnit(
                maxAppertureHeight,
                newThisReelApperture,
                newThisReelReservedSpaces
              ) * newNormalisedSpeed; // how long to spin one of the symbols on this reel

            // keep increasing this reels spin time until it is no closer to the nextReels time than the staggered gap
            while (
              newThisReel + newThisTimeToSpinOneSymbol <
              newNextReel - newStaggeredGap
            ) {
              newThisReel += newThisTimeToSpinOneSymbol;
            }

            travelTimes[j] = newThisReel;
          }
        }
      }

      this._reelsSpinning = [];

      // configure the injectors and land the reels
      for (let i = 0; i < this.reels.length; ++i) {
        if (this._reelsHeld.indexOf(i) !== -1) continue;

        if (
          this._dynamicSpinnerActive &&
          landConfig[`reel${i}`] === undefined
        ) {
          continue;
        }

        let reverseSpin = this.reels[i]._reelParameters.reverse;
        let currentReelApperture = this.reels[i].getCurrentAppertureHeight();
        let symbolsToTravelTargetOnly = travelDistanceUntilLanded[i];

        // travel time currently stores how many seconds until FULL land. However we now want to convert this to the number
        // of symbols we need to spin for the injector that should match this travel time. The injector uses two pieces of information
        // min symbols to spin before switching to target symbols, and the number of target symbols. We already have number of target
        // symbols (symbolsToTravelTargetOnly). Now we just need the dynamic min symbols. We can calculate this by removing the time
        // it takes to spin just the landing symbols from the total time and then the preapperture symbol. Preapperture is calculated
        // seperately as it maybe a different appertureheight than the target symbols. We thenhen calcule the number of symbols
        // we need to spin to  take up this travel time

        // calculate preapperture time
        let leftOver =
          1 - this.reels[i].getRatioOfPreappertureSymbolInView(reverseSpin); // how much of the current preappreture symbol do we still need to spin in

        let preAppertureTargetTime = this.symbolsToTravelUnit(
          maxAppertureHeight,
          this.reels[i].getSymbolAppertureHeight(
            this.reels[i]._preAppertureSymbolIdx
          ),
          leftOver
        );

        // calculate target time
        let targetOnlyTravelTime = this.symbolsToTravelUnit(
          maxAppertureHeight,
          currentReelApperture,
          symbolsToTravelTargetOnly
        );

        //travel time is now left with just the time it takes to spin the minTravelDistanceSymbols
        travelTimes[i] -= targetOnlyTravelTime + preAppertureTargetTime;

        // work out how many symbols it takes to spin the travelTimes
        let minTravelDistanceSymbols = Math.round(
          travelTimes[i] / (maxAppertureHeight / currentReelApperture)
        ); // Math.round purely used for floating point inaccuracies. In theory the travel time should fit perfectly into the number of symbols to spin

        let minTravelDistanceTime = this.symbolsToTravelUnit(
          maxAppertureHeight,
          currentReelApperture,
          minTravelDistanceSymbols
        ); // used for debugging

        let totalTravelTime = this.symbolsToTravelUnit(
          maxAppertureHeight,
          currentReelApperture,
          minTravelDistanceSymbols + symbolsToTravelTargetOnly
        ); //used for debugging

        totalTravelTime += preAppertureTargetTime;

        if (!this._dynamicSpinnerActive) {
          // No post injector in dynamic spinners
          let injectors = this.reels[i].getInjectors();
          injectors.post.setMinTravelDistance(minTravelDistanceSymbols);
          injectors.post.setTargetSymbols(
            this._allReelsTargetSymbols[i],
            symbolsToTravelTargetOnly + 1
          ); // + 1 to get apperture symbol to pos 0
          injectors.post.handOverPreceedingResponisiblity(injectors.pre);
        }

        this._reelsSpinning.push(this.reels[i]._reelId);

        ///////////////////////////////////////////////////////////////////////////////////
        // Dynamic Spinner
        // Tell injectors what symbols to land on
        // dynamic spinners don't care, they just have to tell injectors how far they are
        // spinning and thus where to place land symbols
        // This is done when entering deceleration phase currently but will be moved in the future in case deceleration phase is not present
        // JAMIE - THIS WILL NEED ADDRESSING FOR FUTURE GAMES!!!!
        if (this._dynamicSpinnerActive) {
          this._dynamicSpinners[i].setLandingSymbols(
            this._allReelsTargetSymbols[i],
            aboveSymbolIds[i],
            belowSymbolIds[i]
          );
        }
        this.reels[i].landReel(
          this.onReelLanded.bind(this),
          this.onReelHit.bind(this),
          landConfig
        );
        ///////////////////////////////////////////////////////////////////////////////////

        console.log(
          "Reel " +
            i +
            " CALCULATED to land " +
            totalTravelTime +
            " and spin " +
            (symbolsToTravelTargetOnly + 1 + minTravelDistanceSymbols)
        );
      }
      //            this._reelsSpinning.push(5);
      //           this.reels[5].landReel(this.onReelLanded.bind(this));
    }

    popSymbols(popData, callback) {
      const numReels = this._reelVisuals.length;
      let numReelsPopped = 0;
      function onReelPopComplete() {
        ++numReelsPopped;
        if (numReels === numReelsPopped) {
          callback();
        }
      }

      for (let i = 0; i < this._reelVisuals.length; ++i) {
        this._reelVisuals[i].popSymbols(popData[i], onReelPopComplete);
      }
    }

    dropSymbols(popData, newWindow, callback) {
      const numReels = this._reelVisuals.length;
      let numReelsDropped = 0;
      function onReelDropComplete() {
        ++numReelsDropped;
        if (numReels === numReelsDropped) {
          callback();
        }
      }

      for (let i = 0; i < this._reelVisuals.length; ++i) {
        let numSymbolsDropping = popData[i].reduce(function (prev, cur) {
          return prev + cur;
        }, 0);

        if (numSymbolsDropping !== 0) {
          this._reelVisuals[i].dropSymbols(
            popData[i],
            newWindow[i],
            onReelDropComplete
          );
        } else {
          ++numReelsDropped;
        }
      }
    }

    setMinSymbolSpacingScale(reel, scale = 1.0, postOffset = 0) {
      this.reels[reel].setMinSymbolSpacingScale(scale, postOffset);
    }

    setTempReelBand(reel, reelBand, startingSymbols = []) {
      this.reels[reel].setTempReelBand(reelBand, startingSymbols);
    }

    setTempReelBandLandSymbols(reel, landSymbols) {
      this.reels[reel].setTempReelBandLandSymbols(landSymbols);
    }

    clearTempReelBand(reel) {
      this.reels[reel].clearTempReelBand();
    }

    getLiteralReelPosition(reel) {
      return this.reels[reel].getLiteralReelPosition();
    }

    insertAnticipationSymbols(anticipationSymbols) {
      if (this._dynamicSpinnerActive) {
        let reel = anticipationSymbols.reel;
        this._dynamicSpinners[reel].insertAnticipationSymbols(
          anticipationSymbols
        );
      }
    }

    setInjectorMode(injectorMode) {
      for (let i = 0; i < this._dynamicSpinners.length; i++) {
        this._dynamicSpinners[i].setInjectorMode(injectorMode);
      }
    }
  }

  resourceManager.registerController("SlotMachineEx", function () {
    return new SlotMachine();
  });
})();
